import { z } from 'zod';

export const scheduledWorkflowRunStatusSchema = z.enum([
  'pending',
  // Claimed by the processor; the claim is what stops the sweep double-running a row.
  'running',
  'completed',
  'failed',
  'cancelled',
]);
export type ScheduledWorkflowRunStatus = z.infer<typeof scheduledWorkflowRunStatusSchema>;

export const SCHEDULED_WORKFLOW_RUN_STATUSES = scheduledWorkflowRunStatusSchema.options;

export const SCHEDULED_WORKFLOW_RUN_STATUS_LABELS: Record<ScheduledWorkflowRunStatus, string> = {
  pending: 'Pending',
  running: 'Running',
  completed: 'Completed',
  failed: 'Failed',
  cancelled: 'Cancelled',
};

export const scheduledWorkflowRunSchema = z.object({
  id: z.string().uuid(),
  workflow_id: z.string().uuid(),
  contact_id: z.string().uuid().nullable().optional(),
  run_at: z.string(),
  status: scheduledWorkflowRunStatusSchema,
  payload: z.record(z.string(), z.unknown()).nullable().optional(),
  dedupe_key: z.string().nullable().optional(),
  source_workflow_id: z.string().uuid().nullable().optional(),
  source_node_id: z.string().nullable().optional(),
  source_call_id: z.string().uuid().nullable().optional(),
  started_at: z.string().nullable().optional(),
  completed_at: z.string().nullable().optional(),
  error: z.string().nullable().optional(),
  created_at: z.string(),
  updated_at: z.string(),
});
export type ScheduledWorkflowRun = z.infer<typeof scheduledWorkflowRunSchema>;

export const scheduledWorkflowRunWithRelationsSchema = scheduledWorkflowRunSchema.extend({
  workflow: z.object({ id: z.string().uuid(), name: z.string() }).nullable().optional(),
  contact: z
    .object({ id: z.string().uuid(), name: z.string().nullable(), phone: z.string().nullable() })
    .nullable()
    .optional(),
});
export type ScheduledWorkflowRunWithRelations = z.infer<
  typeof scheduledWorkflowRunWithRelationsSchema
>;

export const scheduledWorkflowRunQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(200).default(25),
  status: scheduledWorkflowRunStatusSchema.optional(),
  workflowId: z.string().uuid().optional(),
  contactId: z.string().uuid().optional(),
  sortOrder: z.enum(['asc', 'desc']).default('asc'),
});
export type ScheduledWorkflowRunQuery = z.infer<typeof scheduledWorkflowRunQuerySchema>;
